/**
 * Created by vsliwka on 10/05/2017.
 */
export class TranslatedValueModel {
  public label: string;
  public order: number;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
